export default "__VITE_ASSET__9674b698__"